import { setCookie, deleteCookie, parseJwt } from "@/helpers/helpers";

export default {
    setCredentials(state, credentials) {
        for(let field in credentials) {
            state.data[field] = credentials[field];
        }
    },
    setTokens(state, tokens) {
        for(let token in tokens) {
            state.tokens[token] = tokens[token];
        }
    },
    loadingTokens(state) {
        state.loading = true;
    },
    successTokens(state, tokens) {
        state.tokens.access = tokens.access;
        const tokensAccess = parseJwt(tokens.access);
        setCookie('tokenAccess', tokens.access, tokensAccess.exp);
        
        if (tokens.refresh) {
            state.tokens.refresh = tokens.refresh;
            const tokensRefresh = parseJwt(tokens.refresh);
            setCookie('tokenRefresh', tokens.refresh, tokensRefresh.exp);
        }

        state.success = true;
        state.error = false;
        state.loading = false;
    },
    errorTokens(state, error) {
        state.success = false;
        state.error = error;
        state.loading = false;
    },
    resetSuccessTokens(state) {
        state.success = false;
        state.error = false;

        state.data.email = '';
        state.data.password = '';

        state.loading = false;
    },
    logout(state) {
        deleteCookie('tokenAccess');
        deleteCookie('tokenRefresh');
        state.tokens.access = '';
        state.tokens.refresh = '';
    },
}
